<div
  class="btn_area_right tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
  <button type="button" mat-raised-button color="primary" class="btn" id="navigateButton"
    (click)="onClickButtonEvent.emit('3')">お客さま照会</button>
  <button type="button" [disabled]="invalidCancelButton" mat-raised-button color="primary" class="btn" id="cancelButton"
    (click)="onClickButtonEvent.emit('2')">中断</button>
  <button type="button" [disabled]="invalidResistButton" mat-raised-button color="primary" class="btn" id="resistButton"
    (click)="onClickButtonEvent.emit('1')">登録</button>
</div>